import { render, staticRenderFns } from "./AssignRoutes.vue?vue&type=template&id=6cc011d2&"
import script from "./AssignRoutes.vue?vue&type=script&lang=js&"
export * from "./AssignRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports